import { render, staticRenderFns } from "./TaskPerformanceRegionReportComponent.vue?vue&type=template&id=df39f86e&scoped=true"
import script from "./TaskPerformanceRegionReportComponent.vue?vue&type=script&lang=js"
export * from "./TaskPerformanceRegionReportComponent.vue?vue&type=script&lang=js"
import style0 from "./TaskPerformanceRegionReportComponent.vue?vue&type=style&index=0&id=df39f86e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df39f86e",
  null
  
)

export default component.exports